import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ClerkAuthProvider from "@/components/auth/ClerkAuthProvider";
import { MeProvider } from "@/context/MeContext";
import { PlayerProvider } from "@/context/PlayerContext";
import { Layout } from "@/components/Layout";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Radio from "@/pages/Radio";
import Shows from "@/pages/Shows";
import JoinMedia from "@/pages/JoinMedia";
import { PrivacyPage, TermsPage } from "@/pages/Legal";
import Directory from "@/pages/Directory";
import Credits from "@/pages/Credits";
import PressKit from "@/pages/PressKit";
import Onboarding from "@/pages/Onboarding";
import Dashboard from "@/pages/Dashboard";
import { PaymentCancel, PaymentSuccess } from "@/pages/Payment";
import { HomeGate, SignInPage, SignUpPage } from "@/pages/Auth";

function App() {
  return (
    <BrowserRouter>
      <ClerkAuthProvider>
        <MeProvider>
          <PlayerProvider>
            <Routes>
              <Route element={<Layout />}>
                <Route path="/" element={<HomeGate><Home /></HomeGate>} />
                <Route path="/radio" element={<Radio />} />
                <Route path="/programas" element={<Shows />} />
                <Route path="/suma-tu-medio" element={<JoinMedia />} />
                <Route path="/terminos" element={<TermsPage />} />
                <Route path="/privacidad" element={<PrivacyPage />} />
                <Route path="/medios" element={<Directory />} />
                <Route path="/creditos" element={<Credits />} />
                <Route path="/artista/:id" element={<PressKit />} />
                <Route path="/bienvenida" element={<Onboarding />} />
                <Route path="/panel" element={<Dashboard />} />
                <Route path="/payment/success" element={<PaymentSuccess />} />
                <Route path="/payment/cancel" element={<PaymentCancel />} />
                <Route path="/sign-in/*" element={<SignInPage />} />
                <Route path="/sign-up/*" element={<SignUpPage />} />
              </Route>
            </Routes>
            <Toaster theme="dark" position="top-right" offset={80} />
          </PlayerProvider>
        </MeProvider>
      </ClerkAuthProvider>
    </BrowserRouter>
  );
}

export default App;
